import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=be664bd2&scoped=true&"
import script from "./ProjectsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=be664bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be664bd2",
  null
  
)

export default component.exports